/**
 * Blank model for the Claimant form: a new open claimant invoiced to the claimant (CLM).
 */
export function NewClaimantModel() {
  return {
    EventType: 'insert',
    ClmId: null,
    RepId: null,
    ClientId: null,
    ClmLastName: '',
    ClmFirstName: '',
    ClmClaimNumber: '',
    ClmClaimNumberNoDash: '',
    ClmPhone: '',
    ClmInvoiceType: 'CLM',
    ClmInvoiceCaption: '',
    ClmLanguage: '',
    ClmNote: '',
    ClmWCABNumber: '',
    ClmInsuredParty: '',
    ClmEmployer: '',
    ClmDateOfInjury: '',
    ClmDateOfInjuryStart: null,
    ClmDateOfInjuryEnd: null,
    ClmDateOfLoss: '',
    ClmDateOfLossDate: null,
    ClmStreet: '',
    ClmCity: '',
    ClmState: '',
    ClmZip: '',
    ClmEmail: '',
    ClmSSN: '',
    ClmDOB: null,
    ClmDiagnosis: '',
    ClmGender: '',
    ClmHasAttorneyFlg: false,
    ClmAppAtty: '',
    ClmAppAttyFirm: '',
    ClmAppAttyEmail: '',
    ClmAppAttyPhone: '',
    ClmDefAtty: '',
    ClmDefAttyFirm: '',
    ClmDefAttyEmail: '',
    ClmDefAttyPhone: '',
    ClmOrderedByName: '',
    ClmHeight: '',
    ClmWeight: '',
    ClmStatus: 'Open',
    CreateDateTime: null,
    CreatebyUserId: null,
    UpdateByUserId: null,
    UpdateDateTime: null,
    IsDeletedFlg: false,
    ClientName: '',
    ClientAbbrv: '',
    RepFirstName: '',
    RepLastName: '',
  };
}
